// extracted by mini-css-extract-plugin
module.exports = {"HowItWorks":"HowItWorksNew_HowItWorks__1X3Nz"};